export const landingTestimonials = [
  {
    quote:
      "Namespace Consultants transformed our risk management approach. Their AI solutions reduced our fraud losses by 80% in just 6 months.",
    author: "Anand Joshi",
    role: "CFO, Leading NBFC",
    company: "FinServ India",
    rating: 5,
    photo: "/assets/AnandJoshi.jpeg",
  },
  {
    quote:
      "The audit automation platform they built saved us 2000+ man-hours annually. Exceptional blend of human insight and AI intelligence.",
    author: "Madhav",
    role: "Head of Internal Audit",
    company: "Tech Unicorn",
    rating: 5,
    photo: "/assets/Madhav.jpeg",
  },
  {
    quote:
      "Their predictive risk models helped us proactively identify compliance gaps before they became issues. True partners in our growth.",
    author: "Nitish Garg",
    role: "CEO",
    company: "Fintech Startup",
    rating: 5,
    photo: "/assets/NiteshGarg.jpeg",
  },
  {
    quote:
      "Working with Namespace was a game-changer for our data analytics. They delivered beyond our expectations with innovative AI solutions.",
    author: "Sourabh Mittal",
    role: "CTO",
    company: "E-commerce Platform",
    rating: 5,
    photo: "/assets/SourabhMittal.jpeg",
  },
  {
    quote:
      "Namespace Consultants helped us modernize our analytics stack with practical AI that improved forecasting accuracy and operational visibility.",
    author: "Kartikeya Goel",
    role: "Managing Partner",
    company: "Alka Trading Company",
    rating: 5,
    photo: "/assets/kartikeya.jpeg",
  },
  {
    quote:
      "Namespace Consultants played a key role in helping us streamline our technology processes with reliable and scalable solutions. Their practical approach and technical expertise added real value to our business.",
    author: "Anurag Mani",
    role: "Director",
    company: "Webilius Technologies Pvt. Ltd.",
    rating: 5,
    photo: "/assets/Anu.png",
  },
  {
    quote:
      "Namespace Consultants helped us accelerate AI delivery with reliable, business-ready solutions and a collaborative team.",
    author: "Swetank Chaudhary",
    role: "Founder & CEO",
    company: "Two Edge Global Solutions",
    rating: 5,
    photo: "/assets/ceo.jpeg",
  },
];

export const ourClientsTestimonials = [
  {
    quote:
      "Namespace delivered a production-ready AI pipeline in weeks, not months. Our teams now make faster, clearer decisions.",
    author: "Anand Joshi",
    title: "CFO, Leading NBFC",
  },
  {
    quote:
      "Their audit automation cut manual effort dramatically while improving coverage across all business units.",
    author: "Madhav",
    title: "Head of Internal Audit",
  },
 {
  quote:
    "Namespace consistently delivered high-quality solutions with strong technical expertise and clear communication. Their team understood our requirements quickly and executed with professionalism, helping us scale our platform smoothly.",
  author: "Anurag Mani",
  title: "Director, Webilius Technologies Pvt. Ltd.",
},
  {
  quote:
    "Their automation framework significantly reduced our release cycles and improved product stability. We saw immediate gains in test coverage and delivery speed.",
  author: "Rohit Verma",
  title: "VP Engineering, SaaS Product Company",
}
];
